<template>
  <outro-template @next="next" button-label="Saisir une déclaration d'absence" :status="status">
    <template v-slot:title>
      Déclarer une absence
    </template>
    <template v-slot:sub-title>
      Les règles de la déclaration d'absence
    </template>
    <template v-slot:score-title>
      Vous avez obtenu {{ score }} points !
    </template>
    <template v-slot:success-detail-title>
      Bravo !
    </template>
    <template v-slot:success-detail-content>
      Vous êtes un expert de la déclaration d'absence.
    </template>
    <template v-slot:normal-detail-title>
      Pas mal !
    </template>
    <template v-slot:normal-detail-content>
      Vous connaissez assez bien les règles de déclaration d’absence. <br>
      N’hésitez pas à consulter la fiche memo régulièrement.
    </template>
    <template v-slot:fail-detail-title>
      Oups !
    </template>
    <template v-slot:fail-detail-content>
      Vous avez besoin de revoir les règles de déclaration d’absence. <br>
      Vous devriez réessayer avant de passer à la suite.
      <br>
      <button @click="navigateTo('cardGame')" class="button retry-button">Réessayer</button>
    </template>
  </outro-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'Outro',
  mixins: [stepMixin],
  computed: {
    score () {
      return this.$store.state.cardGameScore
    },
    status () {
      return this.$store.getters.cardGameStatus
    }
  }
}
</script>

<style lang="scss">
.retry-button {
  margin: 0 auto;
}
</style>
